<template>
    <b-card>
        <b-form @submit.stop.prevent="onSubmit">

        <div class="animated fadeIn">
            <b-row>
            <b-col md="12">                
                <b-form>
                    <b-form-group
                        description=""
                        label="Id"
                        label-for="id"
                        :label-cols="3"
                        :horizontal="true">
                        <b-form-input v-model="selectedItem.id" id="id" type="text" class="col-md-2" readonly></b-form-input>
                    </b-form-group>          
                </b-form>
                </b-col>
            </b-row>

            
            <b-row>
            <b-col md="12">
                
                <b-form>
                <b-form-group
                description=""
                label="Pessoa física/jurídica"
                label-for="personType"
                :label-cols="3"
                :horizontal="true">
                <b-form-radio-group id="personType"
                    v-model="selectedItem.personLawTypeId"
                    :plain="true"
                    :options="[
                    {text: 'Pessoa Física ',value: 'F'},
                    {text: 'Pessoa Jurídica',value: 'J'}
                    ]"
                    :checked="3">
                </b-form-radio-group>
                </b-form-group>          
                </b-form>
                </b-col>
            </b-row>

            <b-row>
            <b-col md="12">
                
                <b-form>
                <b-form-group
                description=""
                :label="selectedItem && selectedItem.personLawTypeId == 'J' ? 'CNPJ' : 'CPF'"
                label-for="doc"
                :label-cols="3"
                :horizontal="true">
                <b-input-group  style="width: 300px">
                    <b-input-group-append><b-input-group-text><i class="fa fa-id-card"></i></b-input-group-text></b-input-group-append>
                    <masked-input
                    type="text"
                    name="doc"
                    class="form-control cols-md-2"
                    v-model="selectedItem.doc"
                    :mask="selectedItem && selectedItem.personLawTypeId == 'J' ? [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/] : [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]"
                    :guide="false"
                    placeholderChar="#">
                    </masked-input>
                </b-input-group>
                </b-form-group>          
                </b-form>
            
            </b-col>
            </b-row>


            <b-row>
            <b-col md="12">
                
                <b-form>
                <b-form-group
                description=""
                :label="selectedItem && selectedItem.personLawTypeId == 'J' ? 'Razão social' : 'Nome completo'"
                label-for="name"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.name" id="name" type="text" class="text-uppercase"></b-form-input>
                </b-form-group>          
                </b-form>
            </b-col>
            </b-row>

            <b-row>
            <b-col md="12">
                <b-form>
                <b-form-group
                description=""
                :label="selectedItem && selectedItem.personLawTypeId == 'J' ? 'Nome fantasia' : 'Apelido'"
                label-for="alias"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.alias" id="alias" type="text" class="text-uppercase"></b-form-input>
                </b-form-group>          
                </b-form>
            </b-col>
            </b-row>

            
            <b-row>
            <b-col md="12">
                <b-form>
                <b-form-group
                description=""
                :label="selectedItem && selectedItem.personLawTypeId == 'J' ? 'Data de abertura' : 'Data de nascimento'"
                label-for="daten"
                :label-cols="3"
                :horizontal="true">
                <div>
                    <b-row>
                    <b-col><b-form-input v-model="selectedItem.daten" type="date" id="daten"></b-form-input></b-col>
                    <b-col  cols="12" md="auto"><span v-show="false">{{ selectedItem && selectedItem.personLawTypeId == 'J' ? 'Data de encerramento' : 'Data de falecimento' }}</span></b-col>
                    <b-col><span v-show="false"><b-form-input v-model="selectedItem.dated" type="date" id="dated"></b-form-input></span></b-col>
                    </b-row>
                    
                </div>
                </b-form-group>          
                </b-form>
            </b-col>
            </b-row>

            <b-row v-show="selectedItem && selectedItem.personLawTypeId == 'F'">
            <b-col md="12">
                
                <b-form>
                <b-form-group
                description=""
                label="Sexo"
                label-for="gender"
                :label-cols="3"
                :horizontal="true">
                <b-form-radio-group id="gender"
                    v-model="selectedItem.genderId"
                    :plain="true"
                    :options="[
                    {text: 'Masculino',value: '1'},
                    {text: 'Feminino',value: '2'},
                    {text: 'N/A',value: '3'}
                    ]"
                    :checked="3">
                </b-form-radio-group>
                </b-form-group>          
                </b-form>
                </b-col>
            </b-row>

            <hr>

            <b-row>
            <b-col md="12">
                <b-form>
                <b-form-group
                description=""
                label="E-mail"
                label-for="email"
                :label-cols="3"
                :horizontal="true">
                <div>
                    
                    <b-input-group>
                    <b-input-group-append><b-input-group-text><i class="fa fa-envelope-o"></i></b-input-group-text></b-input-group-append>
                    <b-form-input v-model="selectedItem.email" type="email" placeholder="" autocomplete="email" class="text-lowercase"></b-form-input>
                    
                    </b-input-group>
                </div>
                </b-form-group>          
                </b-form>
            </b-col>
            </b-row>

            <b-row>
            <b-col md="12">
                <b-form>
                <b-form-group
                description=""
                label="E-mail NFE"
                label-for="emailNfe"
                :label-cols="3"
                :horizontal="true">
                <div>
                    
                    <b-input-group>
                    <b-input-group-append><b-input-group-text><i class="fa fa-envelope-o"></i></b-input-group-text></b-input-group-append>
                    <b-form-input v-model="selectedItem.emailNfe" type="email" placeholder="" class="text-lowercase"></b-form-input>
                    
                    </b-input-group>
                </div>
                </b-form-group>          
                </b-form>
            </b-col>
            </b-row>

            <b-row>
            <b-col md="12">
                
                <b-form>
                <b-form-group
                description=""
                label="Telefone"
                label-for="phone1"
                :label-cols="3"
                :horizontal="true">
                
                <b-input-group style="width: 200px">
                    <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class='fa fa-mobile-phone'></i>
                    </span>
                    </div>
                    <masked-input
                    type="tel"
                    name="phone1"
                    class="form-control"
                    v-model="selectedItem.phone1"
                    :mask="selectedItem.phone1 && selectedItem.phone1.length > 14 ? ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/]"
                    :guide="false"
                    placeholderChar="#">
                    </masked-input>
                </b-input-group>
                
                
                </b-form-group>          
                </b-form>
            
            </b-col>
            </b-row>

            <b-row>
            <b-col md="12">
                
                <b-form>
                <b-form-group
                description=""
                label=""
                label-for="phone2"
                :label-cols="3"
                :horizontal="true">
                
                <b-input-group style="width: 200px">
                    <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class='fa fa-mobile-phone'></i>
                    </span>
                    </div>
                    <masked-input
                    type="tel"
                    name="phone2"
                    class="form-control"
                    v-model="selectedItem.phone2"
                    :mask="selectedItem.phone2 && selectedItem.phone2.length > 14 ? ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/]"
                    :guide="false"
                    placeholderChar="#">
                    </masked-input>
                </b-input-group>
                
                
                </b-form-group>          
                </b-form>
            
            </b-col>
            </b-row>


            <b-row>
            <b-col md="12">
                
                <b-form>
                <b-form-group
                description=""
                label="Telefone comercial"
                label-for="phone3"
                :label-cols="3"
                :horizontal="true">
                
                <b-input-group style="width: 200px">
                    <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class='fa fa-phone'></i>
                    </span>
                    </div>
                    <masked-input
                    type="tel"
                    name="phone3"
                    class="form-control"
                    v-model="selectedItem.phone3"
                    :mask="selectedItem.phone3 && selectedItem.phone3.length > 14 ? ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/]"
                    :guide="false"
                    placeholderChar="#">
                    </masked-input>
                </b-input-group>
                
                
                </b-form-group>          
                </b-form>
            
            </b-col>
            </b-row>

            <hr>

            <b-row v-show="selectedItem.id && selectedItem.id > 0">
            <b-col md="12">
                <b-form>
                <b-form-group
                description=""
                label="Tipo de cadastro"
                label-for="personType"
                :label-cols="3"
                :horizontal="true">
                <v-select v-model="selectedItem.types" multiple :options="personTypeDDL" placeholder="Selecione os tipos de cadastro"></v-select>
                </b-form-group>          
                </b-form>
            </b-col>
            </b-row>

            <hr>

            <b-row>
            <b-col md="12">
                <b-form>
                <b-form-group
                description=""
                label="Observação"
                label-for="notes"
                :label-cols="3"
                :horizontal="true">
                <div>
                    
                    <b-form-textarea
                    id="notes"
                    v-model="selectedItem.notes"
                    placeholder=""
                    rows="3"
                    ></b-form-textarea>
                </div>
                </b-form-group>          
                </b-form>
            </b-col>
            </b-row>

            <b-input-group class="mb-4">
                <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
            </b-input-group>

            <div slot="footer" class="text-right">
            <!--
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
            <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
            -->
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Pessoa</span></b-button>
            
            </div>
                
        </div>
        </b-form>
    </b-card>
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  import MaskedInput from 'vue-text-mask'
  import vSelect from 'vue-select'
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
    //import { table } from 'console'
    
    const toastTypes = {
      success: 'success',
      error: 'error',
      info: 'info',
      warn: 'warn'
    }
    
    miniToastr.init({types: toastTypes})
    
    function toast ({title, message, type, timeout, cb}) {
      return miniToastr[type](message, title, timeout, cb)
    }
    
    const options = {
      success: toast,
      error: toast,
      info: toast,
      warn: toast
    }
    VueNotifications.setPluginOptions(options)
    
    Vue.use(VueNotifications, options)
    /* Toast - End */
  
    export default {
      name: 'PersonAddressComponent',
      props: {
         item: {},
         typeDDL: [],
         personTypeDDL: [],
         companyId: 0
      },
      computed: {
          selectedItem() {
              return this.item
          }
      },
      components: {
        Event,
        MaskedInput,
        vSelect
      },
      data: () => {
          return {
            isBusyDoc: false,
            errorMessage: ''
          }
      },
      methods: {
        async saveItem(currentItem) {
          var s = this;
          var isNewPerson = !currentItem.id;
          var postData = {...currentItem};
          var currentUser = this.$store.state.currentUser

          postData["companyId"] = this.companyId
          postData["currentUserId"] = currentUser.id
          postData["currentUserSid"] = currentUser.sid

          await axios.post(
              this.$store.state.ws_url + "/person",
              postData
          ).then(function(resp) {
              s.$emit('resp', {
                code: 1,
                message: isNewPerson ? 'Pessoa criada. Inclua endereços, documentos e demais informações.' : 'Pessoa alterada com sucesso.',
                isNew: isNewPerson,
                id: resp.data.obj
              })
            }
          ).catch(function (error) {
            console.log(error);

            toast ({
              type: VueNotifications.types.warn,
              title: 'Pessoa',
              message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
              timeout: 5000
            })
            
          });
        },

        save() {

          let msgError = [];

          if(this.selectedItem.name.length <= 3)
            msgError.push("Nome/Razão social");

          if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

            toast ({
              type: VueNotifications.types.error,
              title: 'Pessoa',
              message: msgErrorExt,
              timeout: 5000
            })
          }
          else {
            this.saveItem(this.selectedItem);
          }

        },
      }
    }
  
  </script>